<div class="dropdown-wrapper" (click)="$event.stopPropagation()">
  <!-- ── Trigger ── -->
  <div
    class="dropdown-input"
    [class.active]="isOpen"
    [class.filled]="!!displayValue"
    [class.has-error]="showError"
    [class.locked]="locked"
    (click)="toggle($event)"
  >
    <span class="input-label">
      {{ label }}<span *ngIf="required" class="required-star"> *</span>
      <!-- Icône cadenas -->
      <svg
        *ngIf="locked"
        class="lock-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    </span>
    <div class="input-content">
      <span class="input-text" [class.placeholder]="!displayValue">
        {{ displayValue || placeholder }}
      </span>

      <!-- Clear × (masqué si verrouillé) -->
      <button
        *ngIf="displayValue && !locked"
        class="clear-btn"
        (click)="clearSelection($event)"
        title="Clear"
        type="button"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      <!-- Chevron (masqué si verrouillé) -->
      <span *ngIf="!locked" class="chevron" [class.rotated]="isOpen">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </span>
    </div>
  </div>

  <!-- ── Error message ── -->
  <p class="dropdown-hint error" *ngIf="showError">This field is required</p>
  <p class="dropdown-hint error" *ngIf="!showError"></p>

  <!-- ── Panel (non rendu si verrouillé) ── -->
  <div
    class="dropdown-panel"
    *ngIf="isOpen && !locked"
    (click)="$event.stopPropagation()"
  >
    <!-- Search bar -->
    <div class="search-box" *ngIf="searchable">
      <svg
        class="search-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search..."
        class="search-input"
        (click)="$event.stopPropagation()"
      />
    </div>

    <!-- Options -->
    <ul class="options-list">
      <li
        *ngFor="let option of filteredOptions"
        class="option-item"
        [class.selected]="isSelected(option)"
        (click)="selectOption(option, $event)"
      >
        <span class="checkbox" *ngIf="multiple">
          <svg
            *ngIf="isSelected(option)"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>

        <span class="option-icon" *ngIf="option.icon">{{ option.icon }}</span>
        <span class="option-label">{{ option.label }}</span>

        <span class="check-mark" *ngIf="!multiple && isSelected(option)">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
      </li>

      <li class="no-results" *ngIf="filteredOptions?.length === 0">
        No results found
      </li>
    </ul>
  </div>
</div>
